import { useState } from 'react';

import { Route, Routes } from 'react-router-dom';

import { parseErrorMessageFromPointerUK } from '../../../helpers/parseErrorMessageFromPointer/parseErrorMessageFromPointerUK';
import { useCurrentStep } from '../../../hooks/useCurrentStep';
import { useSignup } from '../../../hooks/useSignup';
import { TStateUpdateErrorUK } from '../../../types';
import CompanyDetailsUK from '../../CompanyDetails/CompanyDetailsUK/CompanyDetailsUK';
import CheckSkippedDecision from '../../Decision/CheckSkippedDecision/CheckSkippedDecision';
import ContactUsDecision from '../../Decision/ContactUsDecision/ContactUsDecision';
import Decision from '../../Decision/Decision';
import GetStartedWithPrefillUK from '../../GetStarted/GetStartedWithPrefillUK/GetStartedWithPrefillUK';
import OffersWithOffersCheck from '../../Offers/OffersWithOffersCheck';
import PersonalDetailsCheckWithOffersCheck from '../../PersonalDetails/PersonalDetailsUK/PersonalDetailsCheck/PersonalDetailsCheckWithOffersCheck';
import PersonalDetailsUK from '../../PersonalDetails/PersonalDetailsUK/PersonalDetailsUK';
import RouteSpinner from '../../RouteSpinner/RouteSpinner';
import TradingHistoryUK from '../../TradingHistory/TradingHistoryUK/TradingHistoryUK';
import StateErrorModal from '../StateErrorModal/StateErrorModal';

const SignupRoutesUK = () => {
  const [stateError, setStateError] = useState<TStateUpdateErrorUK>(null);

  const { isLoading, hasAllData } = useSignup();
  const currentStep = useCurrentStep();

  const stepIsNewOrLoading =
    (isLoading || !hasAllData) && currentStep !== 'new';

  if (stepIsNewOrLoading) {
    return <RouteSpinner />;
  }

  const handleStateUpdateError = (error: Error) => {
    const errorMessage = parseErrorMessageFromPointerUK(error);
    setStateError(errorMessage);
  };

  return (
    <>
      <Routes>
        <Route
          path="/new"
          element={
            <GetStartedWithPrefillUK
              handleStateUpdateError={handleStateUpdateError}
            />
          }
        />
        <Route
          path="/business"
          element={
            <CompanyDetailsUK handleStateUpdateError={handleStateUpdateError} />
          }
        />
        <Route
          path="/applicant"
          element={
            <PersonalDetailsUK
              handleStateUpdateError={handleStateUpdateError}
            />
          }
        />
        <Route path="/offers" element={<OffersWithOffersCheck />} />
        <Route
          path="/check"
          element={<PersonalDetailsCheckWithOffersCheck />}
        />
        <Route path="/check-skipped" element={<CheckSkippedDecision />} />
        <Route path="/documents" element={<TradingHistoryUK />} />
        <Route path="/decision" element={<Decision />} />
        <Route path="/contact" element={<ContactUsDecision />} />
        {/* Fallback route */}
        <Route path="/*" element={<RouteSpinner />} />
      </Routes>
      <StateErrorModal
        stateError={stateError}
        handleClose={() => setStateError(null)}
      />
    </>
  );
};

export default SignupRoutesUK;
